let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9l6Gt")).then(() => parcelRequire('a2bAW'));